import React from "react";
import firebase from "./Firebase";
import FormError from "./FormError";

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayName: "",
      email: "",
      passOne: "",
      passTwo: "",
      errorMessage: null,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const itemName = e.target.name;
    const itemValue = e.target.value;

    this.setState({ [itemName]: itemValue }, () => {
      if (this.state.passOne !== this.state.passTwo) {
        this.setState({ errorMessage: "Passwords do not match" });
      } else if (this.state.email.includes("_")) {
        // console.log('email contains underscore');
        this.setState({ errorMessage: "Email cannot contain '_'" });
      } else {
        this.setState({ errorMessage: null });
      }
    });
  }

  signUp = (email, password) => {
    // when user signs up create those credentials for other firebase project
    console.log(email, password);
    // config for other firebase project
    const configGenderClass = {
      apiKey: "AIzaSyBTok0SnPjMXWvRduIJ1DAMLF3rYsx17kA",
      authDomain: "mosquito-gender-classification.firebaseapp.com",
      databaseURL:
        "https://mosquito-gender-classification-default-rtdb.firebaseio.com",
    };

    const configLocalization = {
      apiKey: "AIzaSyBX5gXTYf-mWGgY8ADXUiAUBKlOrFlnERM",
      authDomain: "mosquito-localization.firebaseapp.com",
      databaseURL: "https://mosquito-localization-default-rtdb.firebaseio.com",
    };

    //larvae species classification
    const configSpeciesClassification = {
      apiKey: "AIzaSyC6zxpjRHzw37yNEKL6yfZhXxFESn3mUN0",
      authDomain: "species-classification-d75db.firebaseapp.com",
      databaseURL:
        "https://species-classification-d75db-default-rtdb.firebaseio.com",
    };

    const configAdultSpecies = {
      apiKey: "AIzaSyCrnHZygccNENrJ-iNbAsQ6DO7xHeE7-w4",
      authDomain: "mona-species-class.firebaseapp.com",
      databaseURL: "https://mona-species-class-default-rtdb.firebaseio.com",
    };

    // create user for gender classification
    var genderClass = firebase.initializeApp(
      configGenderClass,
      "Gender Classification"
    );

    genderClass
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(function (firebaseUser) {
        console.log("User " + firebaseUser.uid + " created successfully!");
        //I don't know if the next statement is necessary
        genderClass.auth().signOut();
        genderClass.delete();
      });

    // create user for localization
    var localization = firebase.initializeApp(
      configLocalization,
      "Localization"
    );

    localization
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(function (firebaseUser) {
        console.log("User " + firebaseUser.uid + " created successfully!");
        //I don't know if the next statement is necessary
        localization.auth().signOut();
        localization.delete();
      });

    // create user for species classification
    var speciesClassification = firebase.initializeApp(
      configSpeciesClassification,
      "Species Classification"
    );

    speciesClassification
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(function (firebaseUser) {
        console.log("User " + firebaseUser.uid + " created successfully!");
        //I don't know if the next statement is necessary
        speciesClassification.auth().signOut();
        speciesClassification.delete();
      });

    // create user for adult species
    var adultSpecies = firebase.initializeApp(
      configAdultSpecies,
      "Adult Species Mona"
    );

    adultSpecies
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(function (firebaseUser) {
        console.log("User " + firebaseUser.uid + " created successfully!");
        //I don't know if the next statement is necessary
        adultSpecies.auth().signOut();
        adultSpecies.delete();
      });
  };

  handleSubmit(e) {
    var registrationInfo = {
      displayName: this.state.displayName,
      email: this.state.email,
      password: this.state.passOne,
    };
    //prevent default behaviour
    e.preventDefault();
    //push an authentication event on fb
    firebase
      .auth()
      .createUserWithEmailAndPassword(
        registrationInfo.email,
        registrationInfo.password
      )
      .then(() => {
        this.props.registerUser(registrationInfo.displayName);
      })
      .catch((error) => {
        if (error.message !== null) {
          this.setState({ errorMessage: error.message });
        } else {
          this.setState({ errorMessage: null });
        }
      });

    this.signUp(registrationInfo.email, registrationInfo.password);
  }

  render() {
    return (
      <form className="mt-3" onSubmit={this.handleSubmit}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="card bg-light">
                <div className="card-body">
                  <h3 className="font-weight-light mb-3">Register</h3>
                  <div className="form-row">
                    {this.state.errorMessage !== null ? (
                      <FormError theMessage={this.state.errorMessage} />
                    ) : null}
                    <section className="col-sm-12 form-group">
                      <label
                        className="form-control-label sr-only"
                        htmlFor="displayName"
                      >
                        Name
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        id="displayName"
                        placeholder="Display Name"
                        name="displayName"
                        required
                        value={this.state.displayName}
                        onChange={this.handleChange}
                      />
                    </section>
                  </div>
                  <section className="form-group">
                    <label
                      className="form-control-label sr-only"
                      htmlFor="email"
                    >
                      Email
                    </label>
                    <input
                      className="form-control"
                      type="email"
                      id="email"
                      placeholder="Email Address (without '_' character)"
                      required
                      name="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                    />
                  </section>
                  <div className="form-row">
                    <section className="col-sm-6 form-group">
                      <input
                        className="form-control"
                        type="password"
                        name="passOne"
                        placeholder="Password"
                        value={this.state.passOne}
                        onChange={this.handleChange}
                      />
                    </section>
                    <section className="col-sm-6 form-group">
                      <input
                        className="form-control"
                        type="password"
                        required
                        name="passTwo"
                        placeholder="Repeat Password"
                        value={this.state.passTwo}
                        onChange={this.handleChange}
                      />
                    </section>
                  </div>
                  <div className="form-group text-right mb-0">
                    <button className="btn btn-primary" type="submit">
                      Register
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
export default Register;
